export default __webpack_public_path__ + "static/media/vscode.4506ee50.png";